import { render, staticRenderFns } from "./VipChoice.vue?vue&type=template&id=2830f936&scoped=true&lang=html"
import script from "./VipChoice.vue?vue&type=script&lang=js"
export * from "./VipChoice.vue?vue&type=script&lang=js"
import style0 from "./VipChoice.vue?vue&type=style&index=0&id=2830f936&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2830f936",
  null
  
)

export default component.exports